import { useEffect, useState } from "react";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function AddLitigation(props) {
  const {
    handleSubmit,
    fields,
    errors,
    show,
    onHideFunc,
    values,
    isUpdate,
    id
  } = props;

  const [data, setData] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);

  const handleChange = (e, field) => {
    const fieldData = { ...data };
    if (isUpdate && values.id) {
      fieldData.lit_id = values.id;
    }
    fieldData[field] = e.target.value;
    setData(fieldData);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (handleSubmit) {
      handleSubmit(e, isUpdate, id);
    }
  };

  // Check if all required fields are filled
  const validateForm = () => {
    if (!fields) return false;
    
    const requiredFields = Object.keys(fields);
    const isValid = requiredFields.every(field => {
      const value = data.hasOwnProperty(field) ? data[field] : (values[field] || "");
      return value && value.trim() !== "";
    });
    
    setIsFormValid(isValid);
  };

  useEffect(() => {
    validateForm();
  }, [data, values, fields]);

  useEffect(() => {
    if (!isUpdate) {
      setData({});
    } else if (isUpdate && values) {
      // Initialize data with values when switching to update mode
      setData({ ...values });
    }
  }, [isUpdate, values]);

  // Clear errors when component unmounts or closes
  useEffect(() => {
    if (!show) {
      setData({});
    }
  }, [show]);

  return (
    <Offcanvas
      show={show}
      onHide={onHideFunc}
      placement="end"
      backdrop="static"
      style={{
        maxWidth: '450px',
        width: '450px'
      }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {!isUpdate ? "Create New Litigation" : "Update Litigation"}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body
        style={{
          padding: '1rem',
          overflow: 'visible'
        }}
      >
        <div style={{ minHeight: "200px" }}>
          <div className="sign-user_card">
            <Form
              className="login-content"
              onSubmit={handleFormSubmit}
            >
              <div className="row" style={{ margin: 0 }}>
                {!!fields &&
                  Object.keys(fields).map((field) => (
                    <div className="col-12" key={field} style={{ padding: '0 8px' }}>
                      <Form.Group className="mb-3">
                        {fields[field]["type"] === "text" && (
                          <>
                            <Form.Label>
                              {fields[field]["label"]}
                              <span className="text-danger"> *</span>
                            </Form.Label>
                            <Form.Control
                              name={fields[field]["name"]}
                              type={fields[field]["type"]}
                              value={data.hasOwnProperty(field) ? data[field] : (values[field] || "")}
                              onChange={(e) => handleChange(e, field)}
                              isInvalid={!!errors[field]}
                              maxLength={100}
                              style={{ width: '100%', boxSizing: 'border-box' }}
                            />
                            {errors[field] && (
                              <Form.Control.Feedback type="invalid">
                                {errors[field]}
                              </Form.Control.Feedback>
                            )}
                          </>
                        )}
                      </Form.Group>
                    </div>
                  ))}
              </div>
              <div className="row mt-4" style={{ margin: 0 }}>
                <div className="col-12 text-end" style={{ padding: '0 8px' }}>
                  <Button 
                    type="submit" 
                    variant="primary"
                    className="px-4 py-2 fw-bold"
                    disabled={!isFormValid}
                  >
                    {!isUpdate ? "Create" : "Update"}
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default AddLitigation;